<div>
    <img alt="cibil-logo" src="../../../../assets//images/cibil/powered-by-cibil-logo.png" class="ml-4 mt-4"
        style="width: 51px; height: 30px;" />
</div>
<section class="page-wrapper">
    <article class="heading-portion">
        <h3 class="heading-text mt-2">Verify Your Email ID</h3>
        <p class="heading-sub-text-error">
            {{data.errorMessage}}
        </p>
    </article>
    <article class="body-portion">
        <div class="d-flex justify-content-center font-weight-bold">
            <mat-form-field appearance="outline" class="col-sm-8 text-center font-weight-bold">
                <input matInput type="number" required (input)="handleOtpClick($event.target.value)"
                    onKeyPress="if(this.value.length==6) return false;" />
            </mat-form-field>
        </div>
        <p class="text-color-darker-grey mt-4 resendOtpText" *ngIf="resendEnabled">
            Didn’t receive OTP?  <a (click)="OnResendOtpClicked()" style="cursor: pointer">click here</a> to resend OTP, <span class="text-danger font-weight-bold">(1 attempt is left)</span>
        </p>
        <p class="text-danger font-weight-bold" *ngIf="data.wrongOtpEntered">
            Entered OTP is wrong, {{data.wrongOtpEntered == 1 ? 2 : data.wrongOtpEntered == 2 ? 1 : 0}} attempt is left
        </p>
    </article>
    <article class="footer mt-5 d-flex">
        <button class="btn-outline mr-md-2" (click)="onBackButtonClicked()">Skip</button>
        <div class="d-flex submitButton">
            <!-- <button class="btn-normal" (click)="onVerifyClicked()" [disabled]="isVerifyButtonDisabled()">Verify</button> -->
            <button type="submit" mat-flat-button class="primary" [disabled]="isVerifyButtonDisabled()"
                [disableRipple]="true" (click)="onVerifyClicked()">
                Verify
            </button>
        </div>
    </article>
</section>